"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _react = _interopRequireWildcard(require("react"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _FormModal = _interopRequireDefault(require("../../../components/Modals/FormModal"));
var _Loader = _interopRequireDefault(require("../../../components/Loader"));
var _TextInput = _interopRequireDefault(require("../../../components/TextFields/TextInput"));
var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _Visibility = _interopRequireDefault(require("@mui/icons-material/Visibility"));
var _VisibilityOff = _interopRequireDefault(require("@mui/icons-material/VisibilityOff"));
var _DateInput = _interopRequireDefault(require("../../../components/TextFields/DateInput"));
var _Checkbox = _interopRequireDefault(require("../../../components/Checkbox"));
var _FormGroup = _interopRequireDefault(require("@mui/material/FormGroup"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var Services = _interopRequireWildcard(require("../../../services"));
var _colors = _interopRequireDefault(require("../../../theme/colors"));
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var TerminationModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(TerminationModal, _PureComponent);
  function TerminationModal() {
    var _this;
    (0, _classCallCheck2["default"])(this, TerminationModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, TerminationModal, [].concat(args)), _this.state = {
      anchorEl: null,
      terminationType: null,
      showTerminationModal: false,
      password: '',
      visibility: false,
      signage: {
        name: '',
        signature: '',
        acceptedTerms: false,
        timestampOfAcceptance: null,
        datedOn: null
      }
    }, _this._handleSignageChange = function (type, value) {
      if (type === 'acceptedTerms' && value === true) {
        _this.setState({
          signage: _objectSpread(_objectSpread({}, _this.state.signage), {}, {
            acceptedTerms: true,
            timestampOfAcceptance: dates.getUTC()
          })
        });
        return null;
      }
      _this.setState({
        signage: _objectSpread(_objectSpread({}, _this.state.signage), {}, (0, _defineProperty2["default"])({}, type, value))
      });
      return null;
    }, _this._handleInputChange = function (type, event) {
      _this.setState((0, _defineProperty2["default"])({}, type, event.target.value.toString()));
    }, _this._toggleVisibility = function () {
      _this.setState({
        visibility: !_this.state.visibility
      });
    }, _this._validateSignageBlock = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _this$state, signage, password, passwordError, signageNameError, signageSignatureError, signageDatedOnError, signageAcceptedError;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$state = _this.state, signage = _this$state.signage, password = _this$state.password;
            if (!_this.props.isMasterSite) {
              _context.next = 5;
              break;
            }
            _context.t0 = false;
            _context.next = 8;
            break;
          case 5:
            _context.next = 7;
            return Services.validateInput('checkEmpty', password);
          case 7:
            _context.t0 = _context.sent;
          case 8:
            passwordError = _context.t0;
            _context.next = 11;
            return Services.validateInput('checkEmpty', signage.name);
          case 11:
            signageNameError = _context.sent;
            _context.next = 14;
            return Services.validateInput('checkEmpty', signage.signature);
          case 14:
            signageSignatureError = _context.sent;
            _context.next = 17;
            return Services.validateInput('date', signage.datedOn, _i18n["default"].locale);
          case 17:
            signageDatedOnError = _context.sent;
            signageAcceptedError = !signage.acceptedTerms;
            if (!signageAcceptedError) {
              _context.next = 22;
              break;
            }
            alert(_i18n["default"].t(_tokens["default"].labels.signage.pleaseAcceptAndAcknowledgeChanges));
            return _context.abrupt("return", null);
          case 22:
            if (signage.name !== signage.signature) {
              signageNameError = _i18n["default"].t(_tokens["default"].labels.signage.signageNameError);
            }
            _this.setState({
              signageNameError: signageNameError,
              signageSignatureError: signageSignatureError,
              signageDatedOnError: signageDatedOnError,
              passwordError: passwordError
            });
            if (!(signageNameError || signageSignatureError || signageDatedOnError || passwordError)) {
              _context.next = 26;
              break;
            }
            return _context.abrupt("return", false);
          case 26:
            return _context.abrupt("return", true);
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(TerminationModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var styles = {
        signature: {
          fontFamily: 'AntaraDistance !important',
          fontWeight: 'bold',
          fontSize: 20,
          paddingBottom: 0
        }
      };
      var productNameToTerminate = null;
      if (this.props.productToTerminate.childProductType && this.props.productToTerminate.childProductType.toLowerCase() !== 'primary') {
        productNameToTerminate = this.props.productToTerminate.name.child[this.props.member.language];
      } else {
        productNameToTerminate = this.props.productToTerminate.name.primary[this.props.member.language];
      }
      productNameToTerminate = "".concat(this.props.productToTerminate.type.toUpperCase() === 'VOLUNTARY' ? _i18n["default"].t(_tokens["default"].labels.marketplace.voluntary) : _i18n["default"].t(_tokens["default"].labels.marketplace.optional), " ").concat(productNameToTerminate);
      if (this.props.productToTerminate.type.toUpperCase() === 'OPTIONAL' && !this.props.isMasterSite) {
        return /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
          open: true,
          close: this.props.close,
          title: _i18n["default"].t(_tokens["default"].titles.productTerminationBlockedTitle),
          disableBackdropClick: true,
          disableEscapeKeyDown: true,
          onSave: this.props.close,
          saveButtonText: "close",
          customContainerStyle: {
            width: 500
          }
        }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          align: "left",
          medium: true,
          display: "inline-block"
        }, _i18n["default"].t(_tokens["default"].labels.marketplace.terminationBlocked)));
      }
      return /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: true,
        close: this.props.close,
        title: _i18n["default"].t(_tokens["default"].titles.areYouSure),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
          var isValid;
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2._validateSignageBlock();
              case 2:
                isValid = _context2.sent;
                if (isValid) {
                  _this2.props.save(_this2.state.signage, _this2.props.isMasterSite ? null : _this2.state.password);
                }
                return _context2.abrupt("return", null);
              case 5:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })),
        saveButtonText: _i18n["default"].t(_tokens["default"].labels.marketplace.terminateProduct),
        customContainerStyle: {
          width: 500
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.byClickingTerminate), " ", /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          fontWeight: 'bold'
        }
      }, productNameToTerminate), " ", _i18n["default"].t(_tokens["default"].labels.marketplace.thisCannotBeUndone)), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        align: "left",
        medium: true,
        display: "inline-block",
        margin: "20px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.pleaseEnterPasswordToTerminateProduct)), !this.props.isMasterSite && /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.password),
        value: this.state.password,
        inputProps: {
          endAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], null, this.state.visibility ? /*#__PURE__*/_react["default"].createElement(_Visibility["default"], {
            style: {
              cursor: "pointer",
              color: _colors["default"].darkGrey,
              marginRight: "8px"
            },
            onClick: this._toggleVisibility
          }) : /*#__PURE__*/_react["default"].createElement(_VisibilityOff["default"], {
            style: {
              cursor: "pointer",
              color: _colors["default"].darkGrey,
              marginRight: "8px"
            },
            onClick: this._toggleVisibility
          }))
        },
        onChange: function onChange(value) {
          return _this2._handleInputChange('password', value);
        },
        error: Boolean(this.state.passwordError),
        helperText: this.state.passwordError,
        secure: !this.state.visibility,
        fullWidth: true,
        autofocus: true
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.yourName),
        fullWidth: true,
        value: this.state.signage.name,
        onChange: function onChange(e) {
          return _this2._handleSignageChange('name', e.target.value);
        },
        error: this.state.signageNameError
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.signature),
        fullWidth: true,
        value: this.state.signage.signature,
        onChange: function onChange(e) {
          return _this2._handleSignageChange('signature', e.target.value);
        },
        customInputStyle: styles.signature,
        error: this.state.signageSignatureError
      }), /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.datedOn),
        fullWidth: true,
        value: this.state.signage.datedOn,
        onChange: function onChange(e) {
          return _this2._handleSignageChange('datedOn', e.target.value);
        },
        error: this.state.signageDatedOnError
      }), /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        row: true,
        style: {
          marginTop: 20
        }
      }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
        control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          checked: this.state.signage.acceptedTerms,
          onChange: function onChange() {
            return _this2._handleSignageChange('acceptedTerms', !_this2.state.signage.acceptedTerms);
          },
          value: "acceptedTerms",
          color: "secondary"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          avMedium: true
        }, _i18n["default"].t(_tokens["default"].labels.account.acknowledgeInfoAccuracy))
      }))), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel,
        customImageStyle: {
          top: '50%'
        }
      }));
    }
  }]);
  return TerminationModal;
}(_react.PureComponent);
var _default = exports["default"] = TerminationModal;